import React from 'react';
import Card from '../UI/Card';
import Button from '../UI/Button';
import { useTranslation } from '../../hooks/useTranslation';

// Icon components for each section
const NetDepositIcon = () => (
  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 00-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);

const DepositIcon = () => (
  <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
  </svg>
);

const LoginIcon = () => (
  <svg className="w-5 h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
  </svg>
);

const WithdrawalIcon = () => (
  <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
  </svg>
);

const InfoIcon = () => (
  <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
  </svg>
);

export default function HelpDetail({ onBack }) {
  const { t } = useTranslation();
  
  const helpSections = [
    {
      key: 'net_deposit',
      icon: NetDepositIcon,
      title: 'help.sections.net_deposit.title',
      content: 'help.sections.net_deposit.content',
      color: 'border-blue-200 bg-blue-50'
    },
    {
      key: 'deposit',
      icon: DepositIcon,
      title: 'help.sections.deposit.title',
      content: 'help.sections.deposit.content',
      color: 'border-green-200 bg-green-50'
    },
    {
      key: 'login',
      icon: LoginIcon,
      title: 'help.sections.login.title',
      content: 'help.sections.login.content',
      color: 'border-purple-200 bg-purple-50'
    },
    {
      key: 'withdrawal',
      icon: WithdrawalIcon,
      title: 'help.sections.withdrawal.title',
      content: 'help.sections.withdrawal.content',
      color: 'border-orange-200 bg-orange-50'
    },
    {
      key: 'how_it_works',
      icon: InfoIcon,
      title: 'help.sections.how_it_works.title',
      content: 'help.sections.how_it_works.content',
      color: 'border-gray-200 bg-gray-50'
    }
  ];

  return (
    <Card>
      <h3 className="text-2xl font-bold mb-6 text-center text-heading text-hc-black">
        {t('help.title')}
      </h3>
      
      <div className="space-y-4 mb-6">
        {helpSections.map((section) => {
          const IconComponent = section.icon;
          return (
            <div 
              key={section.key}
              className={`p-4 rounded-lg border ${section.color} hover:shadow-md transition-shadow duration-200`}
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-0.5">
                  <IconComponent />
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-900 mb-2">
                    {t(section.title)}
                  </h4>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    {t(section.content)}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <Button variant="secondary" fullWidth onClick={onBack}>
        {t('common.back')}
      </Button>
    </Card>
  );
} 